/* eslint-disable import/prefer-default-export */
import gql from "graphql-tag";

export const PRODUCT_QUERY = gql`
  query product($id: ID!, $redeemableId: String, $isShowOosProducts: Boolean) {
    product(
      where: { id: $id }
      redeemableId: $redeemableId
      isShowOosProducts: $isShowOosProducts
    ) {
      id
      productSlug
      title
      description
      nutritionInfoLink
      calories
      allergens
      price
      strike_price
      discountPercent
      metaTitle
      metaDescription
      metaHeading
      hasAssortments
      categories {
        id
        title
        slug
        parentId
      }
      options {
        id
        price
        header
        groupId
        maxOptions
        minOptions
        groupTitle
        label
        options {
          id
          title
          description
          shortDescription
          image
          imageSmall
          price
          calories
          oos
          metaTags {
            title
          }
        }
        optionGroupType
      }
      productImage
      maxQuantity
      stores {
        id
        status
        currency {
          name
          code
          symbol
        }
      }
      amountOptions {
        duration
        amount
      }
      availability
      oos
      metaTags {
        title
      }
    }
  }
`;

export const PRODUCT_QUERY_BY_SLUG = gql`
  query productBySlug($slug: String!) {
    productBySlug(where: { product_slug: $slug }) {
      id
      title
      productSlug
      description
      hasAssortments
      options {
        id
      }
    }
  }
`;

export const FIRST_PRODUCT_QUERY = gql`
  query products {
    products(first: 1) {
      id
      title
      description
      calories
      allergens
      price
      productImage
    }
  }
`;

export const STORE_MENU_QUERY_V2 = gql`
  fragment Products on Product {
    id
    productSlug
    title
    productImage
    productImageSmall
    description
    accentImage
    featured
    productCount
    hasAssortments
    price
    strike_price
    discountPercent
    upsellFeatured
    options {
      id
    }
    metaTags {
      title
    }
    calories
    oos
  }
  query STORE_MENU($id: ID!, $isShowOosProducts: Boolean) {
    store(where: { id: $id }, isShowOosProducts: $isShowOosProducts) {
      id
      menuV2 {
        category
        slug
        description
        products {
          ...Products
        }
        children {
          category
          slug
          description
          products {
            ...Products
          }
        }
      }
      categoriesList {
        slug
      }
      currency {
        id
        name
        code
        symbol
      }
    }
  }
`;

export const STORE_PRODUCT_STOCK_QUERY = gql`
  query STORE_PRODUCT_STOCK_QUERY($orderCode: String!, $storeId: ID!) {
    storeProductStock(orderCode: $orderCode, storeId: $storeId) {
      orderProductId
      id
      title
      oos
    }
  }
`;

export const PRODUCT_ASSORTMENT_QUERY = gql`
  query PRODUCT_ASSORTMENT($productId: ID!, $groupIds: [ID!]!, $storeId: ID!) {
    productAssortment(
      productId: $productId
      groupIds: $groupIds
      storeId: $storeId
    ) {
      id
      groupId
      options {
        id
        productId
        quantity
      }
    }
  }
`;

export const PRODUCT_BOX_SLEEVE_QUERY = gql`
  query productBoxSleeve($orderProductId: Int!, $productId: Int!) {
    productBoxSleeve(orderProductId: $orderProductId, productId: $productId) {
      requiredBoxSize {
        id
        title
      }
      availableSleeveOptions {
        id
        title
        description
        shortDescription
        image
        imageSmall
        price
        calories
        oos
        metaTags {
          title
        }
      }
      unavailableSleeveOptions {
        id
        title
        reason
      }
    }
  }
`;
